import { Button, Grid } from "@mui/material";
import { IoMdAdd } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { baseURL, get_data } from "../../../api";
import SearchComponent from "../../../components/SearchComponent";
import EmptyPage from "../../../components/EmptyPage";
import ClientRecordsTable from "../../../components/tables/ClientRecordsTable";
import { useSelector } from "react-redux";
import PermissionDenied from "../../../components/PermissionDenied";

export default function ClientRecords() {

    const page = {
        width: '100%',
        marginBottom: '2%'
    };
    const { isLoggedIn, user_data } = useSelector(state => state.user);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [totalPages, setTotalPages] = useState(null);
    const [totalData, setTotalData] = useState(null);
    const [refresh, setRefresh] = useState(false)
    const [value, setValue] = useState('');

    const getAllRecords = async () => {
        try {
            const data = await get_data(`record/get-record-for-client?pageNumber=${currentPage}`);
            if (data.status === true) {
                setLoading(false);
                setData(data?.data?.records);
                setTotalPages(data?.data?.totalPages);
                setTotalData(data?.data?.totalRecords);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (currentPage) {
            getAllRecords(currentPage);
        }
    }, [currentPage, refresh])


    const handleSearch = async () => {
        setLoading(true);
        if (value.length > 0) {
            const data = await get_data(`record/search-record-for-client/${value}?pageNumber=${currentPage}`)
            // console.log('xxxxxxxxxx', data)
            if (data.status === true) {
                setData(data?.data?.records);
                setTotalPages(data?.data?.totalPages);
                setTotalData(data?.data?.totalRecords);
            }
        } else {
            getAllRecords(currentPage);
        }
        setLoading(false);
    }

    const itemsPerPage = 15;
    const count = data?.length;


    const tableHeader = [
        "S No.", 'Company', "Vendor", "Vehicle No", 'Imei Number', 'Sim Number', 'Device Unique ID', 'Driver', "Install Date", "Activity Date", "Status"
    ]

    const handleCreate = () => {
        setOpen(true)
    }


    if (user_data?.role && user_data?.permissions && !user_data?.permissions?.includes('Record')) {
        return (
                <PermissionDenied title="You don't have permission to access this page" />
            )
        }
    return (
        <>
            <Grid container spacing={0} style={{ ...page, display: "flex", alignItems: 'center', gap: '1%' }}>
                <div style={{ display: 'flex', marginBottom: '1%', width: '100%' }}>
                    <div>
                        <SearchComponent value={value} setValue={setValue} handleSearch={handleSearch} />
                    </div>

                </div>

                {
                    data?.length <= 0 ?
                        <>
                            <EmptyPage tableHeader={tableHeader} />
                        </>
                        :
                        <>
                            <ClientRecordsTable
                                data={data}
                                tableHeader={tableHeader}
                                itemsPerPage={itemsPerPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                count={count}
                                totalData={totalData}
                                totalPages={totalPages}
                                loading={loading}
                                setLoading={setLoading}
                                getAllRecords={getAllRecords}
                                refresh={refresh} setRefresh={setRefresh}
                            />
                        </>
                }
            </Grid>

        </>
    )
}